module.exports = __webpack_public_path__ + "static/media/tickets.080c0b44.jpg";